import utils from "../Utils/config";
import config from "../Utils/";
import axios from "axios";
import strings from "../Utils/strings";
import authService from "./authService";

const axiosInstance = axios.create({
    baseURL: config.baseURL,
    headers: {
        apiKey: process.env.REACT_APP_API_KEY,
    }
});

axiosInstance.interceptors.request.use(
    (config) => {
        config.headers[strings.clinicLogin.label_auth_token] =
            authService.getToken();
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        if (response.status == 403) {
            window.open("/#/" + strings.navigation.forbidden, "_self")
        } else if (response.status == 503 && navigator.onLine) {
            // window.open("/#/" + strings.navigation.serverDown, "_self")
        } else {
            return response.data;
        }
    },
    (error) => {
        if (error.response) {
            if (error.response.status == 403) {
                window.open("/#/" + strings.navigation.forbidden, "_self")
            } else if (error.response.status == 503 && navigator.onLine) {
                // window.open("/#/" + strings.navigation.serverDown, "_self")
            }
        } else if (navigator.onLine) {
            // window.open("/#/" + strings.navigation.serverDown, "_self")
        }
        return Promise.reject(error);
    }
);


async function clinicOverView(obj) {
    try {
        let param = {
            filterType: obj && obj.filterType
        }
        if (obj.from && obj.to) {

            param["from"] = obj.from
            param["to"] = obj.to
        }
        return await axiosInstance.get(utils.apiName.clinicOverView, {
            params: param
        });
    } catch (e) {
        return e.response;
    }
}

async function doctorOverView(obj) {
    try {
        let param = {
            doctorId: obj && obj.doctorId,
            filterType: obj && obj.filterType
        }
        if (obj.from && obj.to) {

            param["from"] = obj.from
            param["to"] = obj.to
        }
        return await axiosInstance.get(utils.apiName.doctorOverView, {
            params: param
        });
    } catch (e) {
        return e.response;
    }
}

async function doctorLoginOverview(obj) {
    try {
        let param = {
            filterType: obj && obj.filterType
        }
        if (obj.from && obj.to) {

            param["from"] = obj.from
            param["to"] = obj.to
        }
        return await axiosInstance.get(utils.apiName.doctorLoginOverview, {
            params: param
        });
    } catch (e) {
        return e.response
    }
}

async function clinicReportGraph(obj) {
    try {
        let param = {
            filterBy: obj && obj.filterBy
        }
        if (obj.from && obj.to) {

            param["from"] = obj.from
            param["to"] = obj.to
        }
        if (obj.doctorId) {
            param["doctorId"] = obj.doctorId
        }
        return await axiosInstance.get(utils.apiName.clinicReportGraph, {
            params: param
        });
    } catch (e) {
        return e.response;
    }
}

async function clinicAppointmentTable(body, page) {
    try {
        return await axiosInstance.post(utils.apiName.clinicAppointmentTable + page, body)
    } catch (e) {
        return e.response;
    }
}

async function doctorAppointmentTable(body, page) {
    try {
        return await axiosInstance.post(utils.apiName.doctorAppointmentTable + page, body)
    } catch (e) {
        return e.response;
    }
}

async function clinicDoctorTable(doctorPage) {
    try {
        return await axiosInstance.get(utils.apiName.clinicDoctorTable + doctorPage);
    } catch (e) {
        return e.response;
    }
}

async function clinicAppointmentExport(body) {
    try {
        return await axiosInstance.post(utils.apiName.clinicAppointmentExport, body);
    } catch (e) {
        return e.response;
    }
}

async function clinicDoctorExport(obj) {
    try {
        return await axiosInstance.get(utils.apiName.clinicDoctorExport, {
            params: {
                to: obj && obj.to,
                from: obj && obj.from
            }
        });
    } catch (e) {
        return e.response;
    }
}

async function doctorLoginAppointmentExport(body) {
    try {
        return await axiosInstance.post(utils.apiName.doctorLoginAppointmentExport, body);
    } catch (e) {
        return e.response;
    }
}

const ClinicReportService = {
    clinicOverView,
    doctorOverView,
    doctorLoginOverview,
    clinicReportGraph,
    clinicAppointmentTable,
    doctorAppointmentTable,
    clinicDoctorTable,
    clinicDoctorExport,
    clinicAppointmentExport,
    doctorLoginAppointmentExport,
}

export default ClinicReportService;